import React from 'react';
import { Container, Card, Spinner } from 'react-bootstrap';
import { useAuth } from '../auth/AuthContext';
import LearnerNavbar from '../components/LearnerNavbar';
import LearningPath from '../components/LearningPath';
import useLearnerData from '../hooks/useLearnerData';

const ModulesPage = () => {
  const { currentUser, userProfile } = useAuth();
  const { modules, progress, loading, error } = useLearnerData(currentUser?.uid, userProfile);

  return (
    <>
      <LearnerNavbar />
      <Container className="mt-4">
        <Card className="shadow-sm border-0">
          <Card.Header className="bg-white">
            <h5 className="mb-0">All Modules</h5>
          </Card.Header>
          <Card.Body>
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" role="status" />
                <p className="mt-3 text-muted">Loading modules...</p>
              </div>
            ) : error ? (
              <div className="text-danger">{error}</div>
            ) : (
              <LearningPath
                modules={modules || []}
                progress={progress || {}}
                loading={loading}
                moduleLinkBase="/learner/module"
              />
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default ModulesPage;
